import React from 'react';

const OneMin: React.FC = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 px-4 sm:px-6 lg:px-8">
            <img src="/oneMin.jpeg" alt="One Min" className="w-full h-full object-cover rounded-2xl" />
        </div>
    )
}

export default OneMin;